import { useProject } from "../../hooks/useQueries";
export default function ProjectItemCount() {
  const { projectItems } = useProject();
  return projectItems?.length > 0 && <span className="ml-1 rounded-full pt-0.5 w-5 h-5 bg-primary-500 text-white text-center text-xs">{projectItems.length} </span>;
}
